import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Constants from '../../../definitions/constants';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';
import LocaleTooling from '../../../tooling/localeTooling';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import { FormattedMessage } from 'react-intl';

/* Actions */
import * as exportConfigurationsAdminActions from '../../actions/exportConfigurationsAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';

/* Components */
import BlueHeader from '../../components/common/inputs/blueHeader';
import ExportFiltersSelectors from '../../components/exportConfigurationsAdmin/exportFiltersSelectors';
import ExportDataSelectors from '../../components/exportConfigurationsAdmin/exportDataSelectors';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityTable from '../../components/common/entity/entityTable';
import Button from '../../components/common/inputs/button';
import CheckBox from '../../components/common/inputs/checkBox';
import Select from '../../components/common/inputs/select';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import TextBox from '../../components/common/inputs/textBox';
import TextBoxArea from '../../components/common/inputs/textBoxArea';
import SelectBiTemplatesPopup from '../../components/exportConfigurationsAdmin/selectBiTemplatesPopup';
import ExportPeriodSelectorPopup from '../../components/exportConfigurationsAdmin/exportPeriodSelectorPopup';

const initialState = {  
  groupsFilter: {
    groups_criteria: Constants.selectKeys.exportConfigurationsAdmin.groupsFilter.ALL,
    groups_selected: [],
  },
  calculationUnitsFilter: {
    calculation_units_criteria: Constants.selectKeys.exportConfigurationsAdmin.calculationUnitsFilter.ALL,
    calculation_units_selected: [],
  },
  metricGroupsDataFilter: {
    metric_groups_criteria: Constants.selectKeys.exportConfigurationsAdmin.metricGroupsDataFilter.EMPTY,
    metric_groups_selected: [],
  },
  metricsDataFilter: {
    metrics_criteria: Constants.selectKeys.exportConfigurationsAdmin.metricsDataFilter.EMPTY,
    metrics_selected: [],
  },
  biTemplatesDataFilter: {
    bi_data_list: [],
  },
  reportsDataFilter: {
    reports_criteria: Constants.selectKeys.exportConfigurationsAdmin.reportsDataFilter.EMPTY,
  },
  modelsDataFilter: {
    models_criteria: Constants.selectKeys.exportConfigurationsAdmin.modelsDataFilter.EMPTY,
    models_selected: []
  },
  exportOptions: {
    only_one_excel_file: false,
    export_scope: Constants.selectKeys.exportConfigurationsAdmin.periodsExcelSeparation.SEPARATED_FILES,
    calculations_export_only_reprocess_delta: false,
    reprocess_criteria: Constants.selectKeys.exportConfigurationsAdmin.reprocessCriteria.ALL_FULL_CALCULATIONS,
    show_marks: false,
  },
  periodsFilter: {
    periods_criteria: Constants.selectKeys.exportConfigurationsAdmin.periodsCriteria.CURRENT_PERIOD,
    periods_selected: [],
  },
  save_current_configuration_form: {
    create_new_configuration: false,
    save_configuration_name: "",
    save_configuration_description: "",
  },
  edit_current_configuration_form: {
    edit_configuration_id: null,
    edit_configuration_name: "",
    edit_configuration_description: "",
  },
  currentConfigurationId: null,
  currentConfigurationName: "",
  currentConfigurationHasChanges: false,
  biTemplatesSelectListValues: [],
  biTemplatesEditIndex: null,
  currentConfigurationMustReset: false,
}

const popupIds = {
  saveCurrentConfigurationPopup: "saveCurrentConfigurationPopup",
  deleteConfigurationConfirmPopup: "deleteConfigurationConfirmPopup",
  selectBiTemplatesPopup: "selectBiTemplatesPopup",
  clearCurrentConfigurationConfirmPopup: "clearCurrentConfigurationConfirmPopup",
  exportConfigurationPopup: "exportConfigurationPopup",
  editConfigurationPopup: "editConfigurationPopup",
}

class ExportConfigurationsAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }
 
  async componentDidMount() {
    // this.props.dashboardActions.getToursStates();
    this.props.actions.getExportConfigurationsList(this.getExportConfigurationsListParams());
    this.props.actions.getMetricsGroupsList();
    this.props.actions.getMetricsList();
    this.props.actions.getModelsList();
    this.props.actions.getPolynomialsList();
    this.props.actions.getBiTemplatesList();
    this.props.actions.getPeriodsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.saveCurrentConfiguration.status],
      [this.props.saveCurrentConfiguration.status],
      intl.formatMessage({ id: "exportConfigurationsAdmin.saveExportConfigurationSuccess" }),
      (this.props.saveCurrentConfiguration.status == 422) ? intl.formatMessage({ id: "exportConfigurationsAdmin.saveExportConfigurationNameAlreadyExistsError" }) :
        intl.formatMessage({ id: "exportConfigurationsAdmin.saveExportConfigurationFailure" }),
      [() => {
        InterfaceTooling.popupHide(popupIds.saveCurrentConfigurationPopup, this.setState.bind(this));        
        InterfaceTooling.popupHide(popupIds.editConfigurationPopup, this.setState.bind(this));
        if(this.state.currentConfigurationMustReset){
          this.setState({ currentConfigurationName: this.state.edit_current_configuration_form.edit_configuration_name });
        }
        this.setState({ currentConfigurationHasChanges: false });
        this.props.actions.getExportConfigurationsList(this.getExportConfigurationsListParams());
        if(this.state.currentConfigurationId == null || this.state.save_current_configuration_form.create_new_configuration) {
          this.setState(initialState);
        }
      }]      
    );
    
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.deleteConfiguration.status],
      [this.props.deleteConfiguration.status],
      intl.formatMessage({ id: "exportConfigurationsAdmin.deleteConfigurationSuccess" }),
      intl.formatMessage({ id: "exportConfigurationsAdmin.deleteConfigurationFailure" }),
      [() => {
        InterfaceTooling.popupHide(popupIds.deleteConfigurationConfirmPopup, this.setState.bind(this));
        if(this.state.currentConfigurationMustReset){
          this.setState(initialState);
        }
        this.props.actions.getExportConfigurationsList(this.getExportConfigurationsListParams());
      }]      
    );

    InterfaceTooling.apiCallResultFeedback(
      [prevProps.exportData.status],
      [this.props.exportData.status],
      intl.formatMessage({ id: "exportConfigurationsAdmin.exportDataSuccess" }),
      (this.props.exportData.status == 406) ? intl.formatMessage({ id: "exportConfigurationsAdmin.exportDataBiTemplatesOnClosedPeriodError" }) :
        intl.formatMessage({ id: "exportConfigurationsAdmin.exportDataFailure" }),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.exportConfigurationPopup])) {
          InterfaceTooling.popupHide(popupIds.exportConfigurationPopup, this.setState.bind(this));
        }
      }]
    );

    if (this.props.periodsList.status===200 && prevProps.periodsList.status !==200) {
      if(this.props.periodsList.data.length > 0) {      
        this.props.handleCheckRouteAvailableTourReference(Constants.app.routes.exportConfigurationsAdmin);
      }
    }
  }

  getExportConfigurationsListParams = () => {
    let queryParams = {
      page: this.props.exportConfigurationsList.page,
      per_page: Constants.interface.fullListPageSize,
      order_fields:["name"],
      order_directions:["asc"],
    };
    return queryParams;
  };

  handleOnChangeFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    if(path == "calculation_units_criteria" || path == "calculation_units_selected") {
      this.handleOnChangeCalculationFilters(event);
    }
    else if(path == "groups_criteria" || path == "groups_selected") {
      this.handleOnChangeGroupFilters(event);
    }
  };
  handleFetchFilterCalculationUnits = async (keyword) => {
    await this.props.actions.getCalculationUnitsList(keyword);
  };
  handleOnChangeCalculationFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = this.state.calculationUnitsFilter[path];
    let calculationFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.calculationUnitsFilter);
    
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let calculation_units = calculationFiltersNew[path]
            
      if(isDelete) { 
        delete calculation_units[index];
        calculation_units = calculation_units.filter(item => item);
      } else {
        var selectedItem = this.props.calculationUnitsFilteredList.data.find(item => item.id==listValue);
        var exists = this.state.calculationUnitsFilter ? this.state.calculationUnitsFilter.calculation_units_selected.find(item => item.id==listValue) : false;
        if(selectedItem && !exists) {
          calculation_units.push({id: listValue, name: selectedItem.name });
        }
        else if(exists) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.warning(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage( {id: "exportConfigurationsAdmin.calculationUnitAlreadyAdded"})),""); 
        }
      }
      value = calculation_units;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    calculationFiltersNew[path] = value;
    
    // if((path=="calculation_units_criteria" && value==Constants.selectKeys.exportConfigurationsAdmin.calculationUnitsFilter.ALL,) ||
    //   (path=="filterGroup" && value!="" && value!=this.state.calculationUnitsFilter.filterGroup)) {
    //   calculationFiltersNew.calculation_units_selected = [];
    // }
    
    this.setState({
      calculationUnitsFilter: calculationFiltersNew,
      currentConfigurationHasChanges: true,
    });    
  };
  handleFetchFilterGroups = async (keyword) => {
    await this.props.actions.getGroupsList(keyword);
  };
  handleOnChangeGroupFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = this.state.groupsFilter[path];
    let groupFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.groupsFilter);
    
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let groups = groupFiltersNew[path]
            
      if(isDelete) { 
        delete groups[index];
        groups = groups.filter(item => item);
      } else {
        var selectedItem = this.props.groupsFilteredList.data.find(item => item.id==listValue);
        var exists = this.state.groupsFilter.groups_selected ? this.state.groupsFilter.groups_selected.find(item => item.id==listValue) : false;
        if(selectedItem && !exists) {
          groups.push({id: listValue, name: selectedItem.name });
        }
        else if(exists) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.warning(intl.formatMessage( {id: "exportConfigurationsAdmin.groupAlreadyAdded"} ),""); 
        }
      }
      value = groups;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    groupFiltersNew[path] = value;
    
    // if((path=="groups" && value==Constants.selectKeys.exportConfigurationsAdmin.groupsFilter.ALL,) ||
    //   (path=="filterGroup" && value!="" && value!=this.state.groupsFilter.filterGroup)) {
    //   groupFiltersNew.groups = [];
    // }
    
    this.setState({
      groupsFilter: groupFiltersNew,
      currentConfigurationHasChanges: true,
    });    
  };

  handleOnChangeDataFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    if(path == "metric_groups_criteria" || path == "metric_groups_selected") {
      this.handleOnChangeMetricGroupsDataFilters(event);
    }
    else if(path == "metrics_criteria" || path == "metrics_selected") {
      this.handleOnChangeMetricsDataFilters(event);
    }
    else if(path == "models_criteria" || path == "models_selected") {
      this.handleOnChangeModelsDataFilters(event);
    }
    else if(path == "reports_criteria") {
      this.handleOnChangeReportsDataFilters(event);
    }
    else if(path == "bi_data_list") {
      this.handleOnChangeBiTemplatesDataFilters(event);
    }
  };
  handleOnChangeMetricGroupsDataFilters = (event) => {
    let metricGroupsDataFilterNew = JavascriptUtilsTooling.deepCopy(this.state.metricGroupsDataFilter);
    let path = event.currentTarget.dataset.path;
    let value = event.currentTarget.value;
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let isDelete = event.currentTarget.dataset.delete;
      
      let metricGroups = metricGroupsDataFilterNew[path]
            
      if(isDelete) { 
        delete metricGroups[index];
        metricGroups = metricGroups.filter(item => item);
      } else {
        var metricGroupProp = this.props.metricsGroupsList.data.find(item => item.id==value)
        metricGroups.push({id: value, name: metricGroupProp.name, metrics: metricGroupProp.metrics});
      }
      value = metricGroups;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    metricGroupsDataFilterNew[path] = value;
    
    this.setState({
      metricGroupsDataFilter: metricGroupsDataFilterNew,
      currentConfigurationHasChanges: true,
    });
  };
  handleOnChangeMetricsDataFilters = (event) => {
    let metricsDataFilterNew = JavascriptUtilsTooling.deepCopy(this.state.metricsDataFilter);
    let path = event.currentTarget.dataset.path;
    let value = event.currentTarget.value;
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let isDelete = event.currentTarget.dataset.delete;
      
      let metrics = metricsDataFilterNew[path]
            
      if(isDelete) { 
        delete metrics[index];
        metrics = metrics.filter(item => item);
      } else {
        var metricProp = this.props.metricsList.data.find(item => item.id==value)
        metrics.push({id: value, name: metricProp.name});
      }
      value = metrics;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    metricsDataFilterNew[path] = value;
    
    this.setState({
      metricsDataFilter: metricsDataFilterNew,
      currentConfigurationHasChanges: true,
    });
  };
  handleOnChangeModelsDataFilters = (event) => {
    let modelsDataFilterNew = JavascriptUtilsTooling.deepCopy(this.state.modelsDataFilter);
    let path = event.currentTarget.dataset.path;
    let value = event.currentTarget.value;
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let isDelete = event.currentTarget.dataset.delete;
      
      let models = modelsDataFilterNew[path]
            
      if(isDelete) { 
        delete models[index];
        models = models.filter(item => item);
      } else {
        var modelProp = this.props.modelsList.data.find(item => item.id==value)
        models.push({id: value, name: modelProp.name});
      }
      value = models;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    modelsDataFilterNew[path] = value;
    
    this.setState({
      modelsDataFilter: modelsDataFilterNew,
      currentConfigurationHasChanges: true,
    });
  }

  handleOnChangeReportsDataFilters = (event) => {
    let reportsDataFilterNew = JavascriptUtilsTooling.deepCopy(this.state.reportsDataFilter);
    let path = event.currentTarget.dataset.path;
    let value = event.currentTarget.value;
    reportsDataFilterNew[path] = value;
    this.setState({
      reportsDataFilter: reportsDataFilterNew,
      currentConfigurationHasChanges: true,
    });
  }


  handleOnChangeExportOptions = (event) => {
    let path = event.currentTarget.dataset.path;
    let type = event.target.type
    let value = type=="checkbox" ? event.currentTarget.checked : event.currentTarget.value;
    let exportOptionsNew = JavascriptUtilsTooling.deepCopy(this.state.exportOptions);
    exportOptionsNew[path] = value;
    if(path=="reprocess_criteria" && value==Constants.selectKeys.exportConfigurationsAdmin.reprocessCriteria.ALL_FULL_CALCULATIONS) {
      exportOptionsNew["calculations_export_only_reprocess_delta"] = false;
    }
    this.setState({
      exportOptions: exportOptionsNew,
      currentConfigurationHasChanges: true,
    });
  }

  handleClearCurrentConfiguration = () => {
    this.setState(initialState);
    if(InterfaceTooling.popupHasToRender(this.state[popupIds.clearCurrentConfigurationConfirmPopup])) {
      InterfaceTooling.popupHide(popupIds.clearCurrentConfigurationConfirmPopup, this.setState.bind(this));
    }
  }
  handleClearCurrentConfigurationPopup = (event) => {
    if(this.state.currentConfigurationHasChanges) {
      InterfaceTooling.handleShowPopup(
        event, popupIds.clearCurrentConfigurationConfirmPopup, this.state,
        this.setState.bind(this), false
      );
    }
    else{
      this.handleClearCurrentConfiguration();
    }
  }

  handleSaveCurrentConfigurationConfirmPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.saveCurrentConfigurationPopup, this.state, 
      this.setState.bind(this), this.props.saveCurrentConfiguration.loading, () => {
        this.setState({
          save_current_configuration_form: initialState.save_current_configuration_form,        
        })
      }
    );
  }
  handleOnChangeSaveCurrentConfigurationForm = (event) => {
    let path = event.currentTarget.dataset.path;    
    let type = event.target.type
    let value = type=="checkbox" ? event.currentTarget.checked : event.currentTarget.value;
    let currentConfigurationFormNew = JavascriptUtilsTooling.deepCopy(this.state.save_current_configuration_form);
    currentConfigurationFormNew[path] = value;
    this.setState({
      save_current_configuration_form: currentConfigurationFormNew,
    });
  }
  handleSaveCurrentConfiguration = async () => {
    let params = {
      configuration: {
        groups_filter: this.state.groupsFilter,
        calculation_units_filter: this.state.calculationUnitsFilter,
        metric_groups_data: this.state.metricGroupsDataFilter,
        metrics_data: this.state.metricsDataFilter,
        bi_templates_data: this.state.biTemplatesDataFilter,
        reports_data: this.state.reportsDataFilter,        
        models_data: this.state.modelsDataFilter,
        export_options: this.state.exportOptions,
      },
      name: this.state.save_current_configuration_form["configuration_name"],
      description: this.state.save_current_configuration_form["save_configuration_description"],
      id: this.state.save_current_configuration_form.create_new_configuration ? null : this.state.currentConfigurationId,      
    };
    this.props.actions.saveExportConfiguration(params);
  }

  handleDeleteConfigurationPopup = (event) => {    
    if(event) {
      event.stopPropagation();
    }
    InterfaceTooling.handleShowPopup(
      event, popupIds.deleteConfigurationConfirmPopup, this.state, 
      this.setState.bind(this), this.props.deleteConfiguration.loading, () => {
        if(event.currentTarget.dataset.entitydata) {
          this.setState({ currentConfigurationMustReset: false });
          let export_configuration = JSON.parse(event.currentTarget.dataset.entitydata);
          this.props.actions.prepareDeleteConfigurationEntity(export_configuration.id);
        }
      }
    );
  }
  handleDeleteCalendarConfirm = (event) => {
    if(this.state.currentConfigurationId == this.props.deleteConfiguration.id) {
      this.setState({ currentConfigurationMustReset: true });
    }
    this.props.actions.deleteConfigurationEntity({id: this.props.deleteConfiguration.id});
  }

  handleSelectBiTemplatesPopup = (event, index=null) => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.selectBiTemplatesPopup, this.state, 
      this.setState.bind(this), false, () => {
        if(index) {
          this.setState({
            biTemplatesSelectListValues: this.state.biTemplatesDataFilter.bi_data_list[index],
          });
        }
        else {
          this.setState({
            biTemplatesSelectListValues: [],
            biTemplatesEditIndex: null,
          });
        }
      }
    );  
  };
  handleOnChangeBiReportsSelectList = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    let dataPath = event.currentTarget.dataset.path;
    let newFormValues = JavascriptUtilsTooling.deepCopy(this.state.biTemplatesSelectListValues);
    if(dataPath=="template_id") {
      newFormValues[event.currentTarget.dataset.selectlist].template_id = value
    }
    else{
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;             
      if(isDelete) { 
        delete newFormValues[index];
        newFormValues = newFormValues.filter(item => item);
      } else {
        newFormValues.push({model_id: listValue, template_id: "defect", name: (this.props.polynomialsList.data.find(item => item.id==listValue)).name});
      }
    }
    this.setState({
      biTemplatesSelectListValues: newFormValues
    });
  }
  handleOnChangeBiTemplatesDataFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let biTemplatesDataFiltersAux = JavascriptUtilsTooling.deepCopy(this.state.biTemplatesDataFilter);
    let newFormValues = biTemplatesDataFiltersAux[path];
    let index = event.currentTarget.dataset.index;
    let isDelete = event.currentTarget.dataset.delete;
    let isEdit = event.currentTarget.dataset.edit;             
    if(isDelete) { 
      delete newFormValues[index];
      newFormValues = newFormValues.filter(item => item);
    }
    else if(isEdit) {
      this.setState({
        biTemplatesSelectListValues: newFormValues,
        biTemplatesEditIndex: index,
      });
      this.handleSelectBiTemplatesPopup(event, index);
    }
    biTemplatesDataFiltersAux[path] = newFormValues;
    this.setState({
      biTemplatesDataFilter: biTemplatesDataFiltersAux,
      currentConfigurationHasChanges: true,
    });
  }
  handleSaveBiTemplatesPopupData = () => {
    let currentBiTemplatesDataFilter = JavascriptUtilsTooling.deepCopy(this.state.biTemplatesDataFilter);
    if(this.state.biTemplatesSelectListValues.length==0 || !this.state.biTemplatesSelectListValues) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.warning(intl.formatMessage({ id: "exportConfigurationsAdmin.biTemplatesPopupSelectOneError" }), "");
      return;
    }
    if(this.state.biTemplatesEditIndex){
      currentBiTemplatesDataFilter.bi_data_list[this.state.biTemplatesEditIndex] = this.state.biTemplatesSelectListValues
    }
    else{
      currentBiTemplatesDataFilter.bi_data_list.push(this.state.biTemplatesSelectListValues)
    }
    this.setState({ 
      biTemplatesDataFilter: currentBiTemplatesDataFilter,
      biTemplatesSelectListValues: [],
      biTemplatesEditIndex: null,      
      currentConfigurationHasChanges: true, 
    });
    this.handleSelectBiTemplatesPopup();
  }
  
  handleOnConfigurationRowClick = (event) => {
    let configurationMetaData = JSON.parse(event.currentTarget.dataset.entitydata);
    let configuration = configurationMetaData.configuration;
    this.setState({
      groupsFilter: JavascriptUtilsTooling.deepCopy(configuration.groups_filter),
      calculationUnitsFilter: JavascriptUtilsTooling.deepCopy(configuration.calculation_units_filter),
      metricGroupsDataFilter: JavascriptUtilsTooling.deepCopy(configuration.metric_groups_data),
      metricsDataFilter: JavascriptUtilsTooling.deepCopy(configuration.metrics_data),
      modelsDataFilter: JavascriptUtilsTooling.deepCopy(configuration.models_data),
      exportOptions: JavascriptUtilsTooling.deepCopy(configuration.export_options),
      biTemplatesDataFilter: JavascriptUtilsTooling.deepCopy(configuration.bi_templates_data),
      reportsDataFilter: JavascriptUtilsTooling.deepCopy(configuration.reports_data),
      currentConfigurationId: configurationMetaData.id,
      currentConfigurationName: configurationMetaData.name,
      currentConfigurationHasChanges: false,
    });
  }

  handleExportConfigurationPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.exportConfigurationPopup, this.state, 
      this.setState.bind(this), false, () => {
        this.setState({ periodsFilter: initialState.periodsFilter });
      }
    );
  }  
  handleOnChangePeriodsFilter = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = event.currentTarget.value;
    let periodsFilterNew = JavascriptUtilsTooling.deepCopy(this.state.periodsFilter);
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let isDelete = event.currentTarget.dataset.delete;
      let periods = periodsFilterNew[path]
      if(isDelete) {
        delete periods[index];
        periods = periods.filter(item => item);
      } else {
        var periodProp = this.props.periodsList.data.find(item => item.id==value)
        periods.push({id: value, name: periodProp.name});
      }
      value = periods;
      periodsFilterNew[path] = value;
      this.setState({
        periodsFilter: periodsFilterNew,
      });
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
      periodsFilterNew[path] = value;
      if(path=="periods_criteria" && (value==Constants.selectKeys.exportConfigurationsAdmin.periodsCriteria.ALL)) {
        periodsFilterNew["periods_selected"] = [];
      }
      else if(path=="periods_criteria" && value==Constants.selectKeys.exportConfigurationsAdmin.periodsCriteria.CURRENT_PERIOD){
        // periodsFilterNew["periods_selected"] = [this.state.currentPeriodId];
        periodsFilterNew["periods_selected"] = [];
      }
      this.setState({
        periodsFilter: periodsFilterNew,
      });
    }
  }
  handleExportConfigurationConfirm = () => {
    if(this.state.periodsFilter.periods_selected.length==0 && (this.state.periodsFilter.periods_criteria==Constants.selectKeys.exportConfigurationsAdmin.periodsCriteria.ALL_EXCEPT || this.state.periodsFilter.periods_criteria==Constants.selectKeys.exportConfigurationsAdmin.periodsCriteria.ONLY)) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.warning(intl.formatMessage({ id: "exportConfigurationsAdmin.periodsFilterNoPeriodsSelectedError" }), "");
      return;
    }
    let params = {
      export_params:{
        export_configuration: {
          groups_filter: this.state.groupsFilter,
          calculation_units_filter: this.state.calculationUnitsFilter,
          metric_groups_data: {
            metric_groups_criteria: this.state.metricGroupsDataFilter.metric_groups_criteria,
            metric_groups_selected: this.state.metricGroupsDataFilter.metric_groups_selected,
          },
          metrics_data: this.state.metricsDataFilter,
          bi_templates_data: this.state.biTemplatesDataFilter,
          models_data: this.state.modelsDataFilter,
          reports_data: this.state.reportsDataFilter,
          export_options: this.state.exportOptions,
        },
        periods_filter: this.state.periodsFilter,
        export_configuration_name: this.state.currentConfigurationName,
      }
    };
    this.props.actions.exportUsingConfiguration(params);
  }

  handleEditCurrentConfiguration = () => {
    let params = {
      id: this.state.edit_current_configuration_form["edit_configuration_id"],
      name: this.state.edit_current_configuration_form["edit_configuration_name"],
      description: this.state.edit_current_configuration_form["edit_configuration_description"],
      only_save_description_and_name: true,      
    };    
    this.setState({ currentConfigurationMustReset: true });
    this.props.actions.saveExportConfiguration(params);
  }

  handleEditConfigurationPopup = (event) => {
    if(event) {
      event.stopPropagation();
    }
    if (event.currentTarget.dataset.entitydata) {
      var entityData = JSON.parse(event.currentTarget.dataset.entitydata);
      var currentName = entityData.name;
      var currentDescription = entityData.description;
      var currentId = entityData.id;
    }
    else {
      var entityData = this.props.exportConfigurationsList.data.find(item => item.id==this.state.currentConfigurationId);
      var currentName = entityData.name;
      var currentDescription = entityData.description;
      var currentId = this.state.currentConfigurationId;
    }
    InterfaceTooling.handleShowPopup(
      event, popupIds.editConfigurationPopup, this.state, 
      this.setState.bind(this), false, () => {
        this.setState({
          edit_current_configuration_form: {
            edit_configuration_id: currentId,
            edit_configuration_name: currentName,
            edit_configuration_description: currentDescription,
          },
        })
      }
    );
  }

  handleOnChangeEditCurrentConfigurationForm = (event) => {
    let path = event.currentTarget.dataset.path;    
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    let currentConfigurationFormNew = JavascriptUtilsTooling.deepCopy(this.state.edit_current_configuration_form);
    currentConfigurationFormNew[path] = value;
    this.setState({
      edit_current_configuration_form: currentConfigurationFormNew,
    });
  }
    

  render() {
    var loadingView = (this.props.metricsGroupsList.firstLoading || this.props.metricsList.firstLoading || this.props.modelsList.firstLoading || this.props.periodsList.firstLoading || this.props.exportConfigurationsList.firstLoading);
    var errorLoadingView = (this.props.metricsGroupsList.status !== null && this.props.metricsGroupsList.status !== 200) ||
     (this.props.metricsList.status !== null && this.props.metricsList.status !== 200) ||
     (this.props.modelsList.status !== null && this.props.modelsList.status !== 200) ||
    (this.props.periodsList.status !== null && this.props.periodsList.status !== 200) ||
    (this.props.exportConfigurationsList.status !== null && this.props.exportConfigurationsList.status !== 200);
    var noPeriodsCreated = this.props.periodsList.status == 200 && this.props.periodsList.data.length==0;
    return (
      <section className="dashboard_content_inner_view export_configurations_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) :
          noPeriodsCreated ? (
            <section className="no_periods_created_section">
              <BlueHeader labelLocale={intl.formatMessage({id: "dashboard.mainMenu.export_configurations_admin"})} />
              <div className="no_period_selected_wrapper">
                {intl.formatMessage({ id: "common.noPeriodCreated" })}
              </div>
            </section>            
          ) :
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <React.Fragment>
              <div className="export_configuration_admin_configuration_filters_and_data_section">
                {(this.state.currentConfigurationId) && (
                  <div className='current_configuration_header'>
                    <BlueHeader 
                      labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.currentConfigurationLabel"}) + ": " +
                        this.state.currentConfigurationName + (this.state.currentConfigurationHasChanges ? "*" : "")}
                      className={"current_configuration_blue_header"}
                    />
                    <i 
                      // data-entitydata={}
                      className="edit_current_configuration_button fas fa-edit"
                      onClick={this.handleEditConfigurationPopup}
                      title={intl.formatMessage({ id: "exportConfigurationsAdmin.editConfigurationTooltip" })}
                    />
                  </div>  
                )}
                {(!this.state.currentConfigurationId) && (
                  <div className='current_configuration_header'>
                    <BlueHeader 
                      labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.newConfigurationTopTitle"})}
                      className={"current_configuration_blue_header"}
                    />
                  </div>  
                )}
                <BlueHeader labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationsFiltersLabel"})} />
                <ExportFiltersSelectors          
                  onChangeFilter={this.handleOnChangeFilters}
                  groupsFilters={this.state.groupsFilter}
                  groupsProps={this.props.groupsFilteredList}
                  groupsFetchAction={this.handleFetchFilterGroups}
                  calculationUnitsFilters={this.state.calculationUnitsFilter}                       
                  calculationUnitsProps={this.props.calculationUnitsFilteredList}
                  calculationUnitsFetchAction={this.handleFetchFilterCalculationUnits}
                />
                <BlueHeader labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationsDataLabel"})} className="data_section_header"/>
                <ExportDataSelectors
                  onChangeDataFilter={this.handleOnChangeDataFilters}
                  metricsGroupsDataFilters={this.state.metricGroupsDataFilter}
                  metricsGroupsList={this.props.metricsGroupsList.data}
                  metricsDataFilters={this.state.metricsDataFilter}
                  metricsList={this.props.metricsList.data}
                  reportsDataFilters={this.state.reportsDataFilter}
                  modelsDataFilters={this.state.modelsDataFilter}
                  modelsList={this.props.modelsList.data}
                  biTemplatesDataFilters={this.state.biTemplatesDataFilter}
                  biTemplatesList={this.props.biTemplatesList.data}
                  handleSelectBiTemplatesPopup={this.handleSelectBiTemplatesPopup}
                />
              </div>
              <div className="export_configuration_admin_table_and_options_section">
                <BlueHeader labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationsTableLabel"})} />
                <EntityTable
                  entityTableDescriptor={TableDescriptors.exportConfigurationsList}
                  data={this.props.exportConfigurationsList.data}
                  loading={this.props.exportConfigurationsList.loading}
                  page={this.props.exportConfigurationsList.page}
                  totalPages={this.props.exportConfigurationsList.totalPages}
                  totalRecords={this.props.exportConfigurationsList.totalRecords}
                  orderBy={this.props.exportConfigurationsList.orderBy}
                  orderByDirection={this.props.exportConfigurationsList.orderByDirection}                  
                  handleCustomActions={[this.handleOnConfigurationRowClick, this.handleDeleteConfigurationPopup]}
                  customActionsIcons={["fas fa-eye", "fas fa-trash"]}
                  customActionsTooltips={[intl.formatMessage({id: "exportConfigurationsAdmin.editConfigurationTooltip"}), intl.formatMessage({id: "exportConfigurationsAdmin.deleteConfigurationTooltip"}),]}
                  handleRowClick={this.handleOnConfigurationRowClick}
                  selectedId={this.state.currentConfigurationId}
                  className="export_configuration_admin_table"
                />
                <div className="export_configuration_options_actions_container">
                  <div className="export_configuration_options_wrapper">
                    <BlueHeader labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationOptionsLabel"})} className={"export_options_header"}/>
                    <React.Fragment>
                      <label className="export_configuration_options_section_label">{intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationOptionsFileStructureLabel"})}</label>
                      <div className="export_configuration_options file_structure_options">
                        <Select 
                          value={this.state.exportOptions["export_scope"]}
                          onChange={this.handleOnChangeExportOptions}
                          labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.exportScopeExportOptionLabel" })}
                          options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.periodsExcelSeparation", "exportConfigurationsAdmin.periodsExcelSeparationOptions", false)}
                          data-path="export_scope"
                        />
                        {/* <CheckBox 
                          className="export_configuration_option only_one_excel_file"
                          id="only_one_excel_file"
                          value={this.state.exportOptions["only_one_excel_file"]}
                          onChange={this.handleOnChangeExportOptions}
                          labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.onlyOneExcelFileExportOptionLabel" })}
                          data-path="only_one_excel_file"
                        /> */}
                      </div>
                    </React.Fragment>
                    <label className="export_configuration_options_section_label">{intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationOptionsReprocessOptionsLabel"})}</label>
                    <div className="export_configuration_options reprocess_options">
                      <Select 
                        value={this.state.exportOptions["reprocess_criteria"]}
                        onChange={this.handleOnChangeExportOptions}
                        labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.reprocessCriteriaExportOptionLabel" })}
                        options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.reprocessCriteria", "exportConfigurationsAdmin.reprocessCriteriaOptions", false)}
                        data-path="reprocess_criteria"
                      />
                      <CheckBox 
                        className="export_configuration_option calculations_export_only_reprocess_delta"
                        id="calculations_export_only_reprocess_delta"
                        value={this.state.exportOptions["calculations_export_only_reprocess_delta"]}
                        onChange={this.handleOnChangeExportOptions}
                        labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.calculationsExportOnlyReprocessDeltaExportOptionLabel" })}
                        data-path="calculations_export_only_reprocess_delta"
                        disabled={this.state.exportOptions["reprocess_criteria"]==Constants.selectKeys.exportConfigurationsAdmin.reprocessCriteria.ALL_FULL_CALCULATIONS}
                      />
                    </div>
                    <label className="export_configuration_options_section_label">{intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationOptionsMetricsAndMetricGroupsLabel"})}</label>
                    <div className="export_configuration_options metric_groups_and_metrics_options">
                      <CheckBox 
                        className="export_configuration_option show_marks"
                        id="show_marks"
                        value={this.state.exportOptions["show_marks"]}
                        onChange={this.handleOnChangeExportOptions}
                        labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.showMarksOptionLabel" })}
                        data-path="show_marks"
                      />
                    </div>
                  </div>
                  <div className="export_configuration_actions_wrapper">
                    <BlueHeader labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationActionsLabel"})} className={"export_actions_header"}/>                    
                    <Button
                      onClick={this.handleClearCurrentConfigurationPopup}
                      labelLocale={intl.formatMessage({ id: "exportConfigurationsAdmin.clearCurrentConfigurationButtonLabel" })}
                      className="clear_configuration_button first_action"
                      title={intl.formatMessage({ id: "exportConfigurationsAdmin.clearCurrentConfigurationButtonLabel" })}
                    />
                    <Button
                      onClick={this.handleSaveCurrentConfigurationConfirmPopup}
                      labelLocale={this.state.currentConfigurationId ? intl.formatMessage({id: "exportConfigurationsAdmin.saveCurrentConfigurationButtonLabel"}) : intl.formatMessage({id: "exportConfigurationsAdmin.createCurrentConfigurationButtonLabel"})}
                      className="save_configuration_button"
                      title={this.state.currentConfigurationId ? intl.formatMessage({id: "exportConfigurationsAdmin.saveCurrentConfigurationButtonLabel"}) : intl.formatMessage({id: "exportConfigurationsAdmin.createCurrentConfigurationButtonLabel"})}
                    />
                    <Button
                      id={"export_with_configuration_button"}
                      onClick={this.handleExportConfigurationPopup}
                      labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.exportWithCurrentConfigurationButtonLabel" })}
                      className="export_with_configuration_button"
                      title={intl.formatMessage({ id: "exportConfigurationsAdmin.exportWithCurrentConfigurationButtonLabel" })}
                    />
                    {(this.state.currentConfigurationId) && (
                      <label className="export_configuration_text_label save_configuration_disclaimer">
                        {intl.formatMessage({id: "exportConfigurationsAdmin.saveConfigurationDisclaimer"})}
                      </label>
                    )}
                  </div>
                </div>
              </div>
              <GlassConfirmPopup
                className="save_configuration_confirm_popup"
                confirmTitle={intl.formatMessage({id: "exportConfigurationsAdmin.saveConfigurationConfirmTitle" })}
                confirmText={intl.formatMessage({id: "exportConfigurationsAdmin.saveConfigurationConfirmText" })}
                cancelButtonLabel={intl.formatMessage({id: "exportConfigurationsAdmin.saveConfigurationCancelButtonLabel" })}
                confirmButtonLabel={intl.formatMessage({id: "exportConfigurationsAdmin.saveConfigurationConfirmButtonLabel" })}
                handleConfirm={this.handleSaveCurrentConfiguration}
                handleCancel={this.handleSaveCurrentConfigurationConfirmPopup}
                popupState={this.state[popupIds.saveCurrentConfigurationPopup]}
                loading={this.props.saveCurrentConfiguration.loading}
                children={
                  <React.Fragment>
                    <div className="save_configuration_form_name_row">
                      {this.state.currentConfigurationId && (
                        <CheckBox 
                          className="create_new_configuration"
                          id="create_new_configuration"
                          value={this.state.save_current_configuration_form["create_new_configuration"]}
                          onChange={this.handleOnChangeSaveCurrentConfigurationForm}
                          labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.createNewConfigurationCheckboxLabel" })}
                          data-path="create_new_configuration"
                        />
                      )}
                      <TextBox 
                        styleType={Constants.interface.inputs.styleType.OUTLINED}
                        type={Constants.interface.inputs.type.TEXT}
                        id="configuration_name"
                        data-path="configuration_name"
                        value={(this.state.currentConfigurationId && !this.state.save_current_configuration_form["create_new_configuration"]) ? this.state.currentConfigurationName : this.state.save_current_configuration_form["configuration_name"]}
                        onChange={this.handleOnChangeSaveCurrentConfigurationForm}
                        labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.fields.name"})}
                        className={"save_configuration_name"}
                        disabled={!(this.state.save_current_configuration_form["create_new_configuration"] || !this.state.currentConfigurationId)}
                      />
                    </div>
                    {(this.state.save_current_configuration_form["create_new_configuration"] || !this.state.currentConfigurationId) && (
                      <div className="save_configuration_form_description_row">
                        <TextBoxArea
                          className="save_configuration_description"
                          id="save_configuration_description"
                          data-path="save_configuration_description"
                          value={this.state.save_current_configuration_form["save_configuration_description"]}
                          onChange={this.handleOnChangeSaveCurrentConfigurationForm}
                          labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.fields.description"})}
                        />
                      </div>
                    )}
                  </React.Fragment>
                }
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                  id={"common.entity.deleteEntityConfirmTitle"}
                  values={{entityNameSingular: (<FormattedMessage id={"exportConfigurationsAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                  id={"common.entity.deleteEntityConfirm"}
                  values={{entityNameSingular: (<FormattedMessage id={"exportConfigurationsAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={this.handleDeleteCalendarConfirm}
                handleCancel={this.handleDeleteConfigurationPopup}
                popupState={this.state[popupIds.deleteConfigurationConfirmPopup]}
                loading={this.props.deleteConfiguration.loading}
              />
              <GlassConfirmPopup
                confirmTitle={intl.formatMessage({id: "exportConfigurationsAdmin.clearCurrentConfigurationConfirmTitle" })}
                confirmText={intl.formatMessage({id: "exportConfigurationsAdmin.clearCurrentConfigurationConfirm" })}
                handleConfirm={this.handleClearCurrentConfiguration}
                handleCancel={this.handleClearCurrentConfigurationPopup}
                popupState={this.state[popupIds.clearCurrentConfigurationConfirmPopup]}
              />
              <SelectBiTemplatesPopup
                handleShowPopup={this.handleSelectBiTemplatesPopup}
                popupState={this.state[popupIds.selectBiTemplatesPopup]} 
                handleOnChangeBiReportsSelectList={this.handleOnChangeBiReportsSelectList}
                selectListValues={this.state.biTemplatesSelectListValues}
                handleButton={this.handleSaveBiTemplatesPopupData}              
                polynomialsData={this.props.polynomialsList.data}
                biTemplatesData={this.props.biTemplatesList.data}
              />
              <ExportPeriodSelectorPopup
                confirmTitle={intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationPopupTitle" })}
                confirmText={intl.formatMessage({id: "exportConfigurationsAdmin.exportConfigurationPopup" })}
                handleConfirm={this.handleExportConfigurationConfirm}
                handleCancel={this.handleExportConfigurationPopup}
                popupState={this.state[popupIds.exportConfigurationPopup]}
                values={this.state.periodsFilter}
                onChange={this.handleOnChangePeriodsFilter}
                loading={this.props.exportData.loading}
                periodsList={this.props.periodsList.data}
              />
              <GlassConfirmPopup
                className="edit_configuration_confirm_popup"
                confirmTitle={intl.formatMessage({id: "exportConfigurationsAdmin.editConfigurationConfirmTitle" })}
                cancelButtonLabel={intl.formatMessage({id: "exportConfigurationsAdmin.saveConfigurationCancelButtonLabel" })}
                confirmButtonLabel={intl.formatMessage({id: "exportConfigurationsAdmin.saveConfigurationConfirmButtonLabel" })}
                handleConfirm={this.handleEditCurrentConfiguration}
                handleCancel={this.handleEditConfigurationPopup}
                popupState={this.state[popupIds.editConfigurationPopup]}
                loading={this.props.saveCurrentConfiguration.loading}
                children={
                  <React.Fragment>
                    <div className="edit_configuration_form_name_row">
                      <TextBox 
                        styleType={Constants.interface.inputs.styleType.OUTLINED}
                        type={Constants.interface.inputs.type.TEXT}
                        id="edit_configuration_name"
                        data-path="edit_configuration_name"
                        value={this.state.edit_current_configuration_form["edit_configuration_name"]}
                        onChange={this.handleOnChangeEditCurrentConfigurationForm}
                        labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.fields.name"})}
                        className={"edit_configuration_name save_configuration_name"}
                      />
                    </div>
                    <div className="edit_configuration_form_description_row">
                      <TextBoxArea
                        className="edit_configuration_description"
                        id="edit_configuration_description"
                        data-path="edit_configuration_description"
                        value={this.state.edit_current_configuration_form["edit_configuration_description"]}
                        onChange={this.handleOnChangeEditCurrentConfigurationForm}
                        labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.fields.description"})}
                      />
                    </div>
                    <div className="edit_configuration_disclaimer">
                      {intl.formatMessage({id: "exportConfigurationsAdmin.editConfigurationDisclaimer"})}
                    </div>
                  </React.Fragment>
                }
              />
            </React.Fragment>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({  
  // getToursState: state.reducer.dashboard.getToursState,  
  calculationUnitsFilteredList: state.reducer.exportConfigurationsAdmin.calculationUnitsFilteredList,
  groupsFilteredList: state.reducer.exportConfigurationsAdmin.groupsFilteredList,
  metricsGroupsList: state.reducer.exportConfigurationsAdmin.metricsGroupsList,
  metricsList: state.reducer.exportConfigurationsAdmin.metricsList,
  modelsList: state.reducer.exportConfigurationsAdmin.modelsList,
  exportConfigurationsList: state.reducer.exportConfigurationsAdmin.exportConfigurationsList,
  saveCurrentConfiguration: state.reducer.exportConfigurationsAdmin.saveCurrentConfiguration,
  deleteConfiguration: state.reducer.exportConfigurationsAdmin.deleteConfiguration,  
  biTemplatesList: state.reducer.exportConfigurationsAdmin.biTemplatesList,
  polynomialsList: state.reducer.exportConfigurationsAdmin.polynomialsList,
  periodsList: state.reducer.exportConfigurationsAdmin.periodsList,
  exportData: state.reducer.exportConfigurationsAdmin.exportData,
  handleCheckRouteAvailableTourReference: state.reducer.dashboard.handleCheckRouteAvailableTourReference, 
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(exportConfigurationsAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

ExportConfigurationsAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportConfigurationsAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/exportConfigurationsAdmin/index.jsx